import { render, staticRenderFns } from "./PaymentFailedOrders.vue?vue&type=template&id=29423f66&scoped=true"
import script from "./PaymentFailedOrders.vue?vue&type=script&lang=js"
export * from "./PaymentFailedOrders.vue?vue&type=script&lang=js"
import style0 from "./PaymentFailedOrders.vue?vue&type=style&index=0&id=29423f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29423f66",
  null
  
)

export default component.exports